import * as React from 'react'
import { DatePicker } from '@mui/x-date-pickers'
import FormHelperText from '@mui/material/FormHelperText'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import * as styles from './Date.module.scss'
import { Controller, useFormContext } from 'react-hook-form'
import dayjs from 'dayjs'

export const Date = ({
  name,
  label,
  error,
  required,
  views,
  format,
  inputFormat,
  fieldStyle,
  disabled,
}) => {
  const { control } = useFormContext()

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value, ref } }) => {
        // Convert value to dayjs object if it's not already one
        const dayjsValue = value
          ? dayjs.isDayjs(value)
            ? value
            : dayjs(value)
          : null

        return (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              views={views}
              format={format}
              required={required}
              label={label}
              slotProps={{
                field: {
                  InputProps: {
                    sx: fieldStyle,
                    classes: {
                      root: styles.root,
                    },
                  },
                },
                textField: {
                  required: required,
                  InputLabelProps: {
                    shrink: true,
                    required: required,
                    classes: {
                      asterisk: styles.asterisk,
                    },
                  },
                },
              }}
              disableFuture
              onChange={onChange}
              onAccept={onChange}
              value={dayjsValue}
              inputRef={ref}
              disabled={disabled}
            />
            {error && (
              <FormHelperText error={!!error} id={name}>
                {error && error.message}
              </FormHelperText>
            )}
          </LocalizationProvider>
        )
      }}
    />
  )
}
